import { render, staticRenderFns } from "./detail-comic-staff.vue?vue&type=template&id=44d62f0c"
import script from "./detail-comic-staff.vue?vue&type=script&lang=tsx"
export * from "./detail-comic-staff.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports